import React, { Fragment, useEffect, useState } from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import {
  gAPI_THREAD_SUMMARY,
  post_API_CREATE_TICKET,
  gAPI_THREAD_DYNAMIC_SUMMARY,
  API_EMAIL_STATS,
  gAPI_AZURE_THREAD_DYNAMIC_SUMMARY
} from "./../../constants/api";
import loader from "../../assets/images/plugin_loader.gif";
import Reply from "../components/Reply";
import Help from "../components/Help";
import ARI from "../components/ARI";
import Search from "../components/Search";
import Languages from "../../constants/languages";
import IntlMessages from "../helpers/IntlMessages";
import Ticket from "../components/Ticket";
import moment from "moment";
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
const Main = ({
  gid,
  pid,
  iid,
  propertyDetails,
  email,
  locale,
  ariIntegration,
  service,
  emailIntegration,
  questionSetDetails,
  authContext,
  propertyList,
  allowedProperty,
  handleProperty,
  handleUpdateSettings,
  isSuperAdmin
}) => {
  const [reply, setReply] = useState("");
  const [page, setPage] = useState("main");
  const [threadResponse, setThreadResponse] = useState();
  const [loading, setLoading] = useState(false);
  const [threadLoading, setThreadLoading] = useState(true);
  const [responseList, setResponseList] = useState([]);
  const [cid, setCID] = useState(generateUUID() || "");
  const [statsId, setStatsId] = useState();
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [settings, setSettings] = useState({
    gid: '',
    iid: ''
  });
  const [mailStatsChange, setMailStatsChange] = useState({
    pasteToOutlook: false,
    replyGenerated: false,
    copyDraft: false,
  });
  function mailContextChange() {
    Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, function (bodyTtext) {
      if (emailIntegration !== undefined) {
        if (questionSetDetails !== undefined) {
          setPage("main");
          let tools = [];
          if (questionSetDetails?.flowInvokeApi && questionSetDetails.flowInvokeApi?.isEnabled == true)
            tools = questionSetDetails.flowInvokeApi?.json;
          handleSummary((Office.context.mailbox?.initialData?.subject ?? '') + ' ' + bodyTtext["value"], questionSetDetails?.instructions, tools, questionSetDetails.openAiModel === "AzureGpt4" ? gAPI_AZURE_THREAD_DYNAMIC_SUMMARY : gAPI_THREAD_DYNAMIC_SUMMARY, questionSetDetails.openAiVerbosity);
        } else {
          setPage("main");
          let flow = emailIntegration?.channelDetails && emailIntegration?.channelDetails?.autonomousReplies;
          handleSummary((Office.context.mailbox?.initialData?.subject ?? '') + ' ' + bodyTtext["value"], flow?.instructions, [], questionSetDetails?.openAiModel === "AzureGpt4" ? gAPI_AZURE_THREAD_DYNAMIC_SUMMARY : gAPI_THREAD_DYNAMIC_SUMMARY, questionSetDetails.openAiVerbosity);
        }
      }
    });
  }

  const handleManage = async (type, resposne) => {
    switch (type) {
      case "reply":
        if (resposne !== "") setReply(resposne);
        return;
      case "threadSummary":
        handleSummary(resposne);
        return;
      case "page":
        setPage(resposne);
        return;
      case "responseList":
        setResponseList(resposne);
        return;
      case "sendReply":
        await Office.context.mailbox.item.displayReplyAllFormAsync(resposne);
        return;
      case "updateStats":
        setMailStatsChange(resposne);
        return;
    }
  };

  const handleSummary = (text, systemInstructions, tools, url, verbosity) => {
    setThreadResponse();
    setThreadLoading(true);
    let properties = {
      customer_sentiment: {
        type: "string",
        description: "Sentiment of the customer in the email",
        enum: ["Positive", "Neutral", "Negative"],
      },
      priority: {
        type: "string",
        description: "Priority of the email",
        enum: ["High", "Medium", "Low"],
      },
      email_history: {
        type: "object",
        required: ["FirstMessage", "LastMessage", "ThreadCount"],
        properties: {
          FirstMessage: {
            type: "string",
            description: "Date and time of the first message in the email thread in ISO 8601 format",
          },
          LastMessage: {
            type: "string",
            description: "Date and time of the latest message in the email thread in ISO 8601 format",
          },
          ThreadCount: {
            type: "string",
            description: "Total number of threads in the email",
          },
        },
        additionalProperties: false,
      },
      summary: {
        type: "string",
        description: "Short summary of the email",
      },
      language: {
        type: "string",
        description: "ISO language code of the customer email",
      },
      name: {
        type: "string",
        description: "Name of the person who start the email thread otherwise its empty",
      },
      check_in_date: {
        type: "string",
        description: "Start date of reservation in the email thread in ISO 8601 format",
      },
      check_out_date: {
        type: "string",
        description: "End date of reservation in the email thread in ISO 8601 format",
      },
      adults: {
        type: "string",
        description: "Number of adults for reservations in the email thread in ISO 8601 format otherwise",
      },
      agent: {
        type: "string",
        description: "Name of reservation agent define in the email thread otherwise leave its blank",
      },
      reservation_number: {
        type: "string",
        description: "Reservation Number define in the email thread otherwise its empty",
      },
      corporate_code: {
        type: "string",
        description: "Coporate code define  in the email thread otherwise its empty",
      },
      group_code: {
        type: "string",
        description: "Group code define  in the email thread otherwise its empty",
      },
      promo_code: {
        type: "string",
        description: "Promo code define  in the email thread otherwise its empty",
      },
      property_name: {
        type: "string",
        description: "Name of the hotel in the email thread otherwise its empty",
      },
      booking_number: {
        type: "string",
        description: "Booking number of the booking in the email thread otherwise its empty",
      },
      topics: {
        type: "string",
        description: "Topic of the email",
        enum: propertyDetails?.topics && propertyDetails?.topics.length > 0 ? propertyDetails?.topics : [
          "New Reservation",
          "Existing Reservation",
          "Lost & Found",
          "General Inquiry",
          "Group Inquiry",
          "Pre-Arrival Message",
        ],
      },
    };
    let required = [
      "customer_sentiment",
      "priority",
      "email_history",
      "summary",
      "topics",
      "language",
      "name",
      "check_in_date",
      "check_out_date",
      "adults",
      "agent",
      "reservation_number",
      "corporate_code",
      "group_code",
      "promo_code",
      "booking_number",
      "property_name"
    ];
    fetch(url, {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        groupId: gid,
        propertyId: pid,
        language: "en",
        q: "",
        suffix: "",
        conversationId: cid,
        indexVersion: propertyDetails?.searchIndexVersion,
        index: propertyDetails?.searchIndexName,
        verbosity: verbosity ? verbosity : "medium",
        propertyName: propertyDetails?.name,
        modelName: questionSetDetails?.openAiModel === "AzureGpt4" ? "gpt-4o-mini" : questionSetDetails?.openAiModel,
        history: [{ human: text }],
        systemInstructions: "Today Date is : " + moment().format("YYYY-MM-DD") + systemInstructions,
        tools: [],
        properties: properties,
        required: required,
        response_format: {
          name: "message_response",
          description: "Summarizes the email thread including sentiment, thread count, and topics discussed.",
          strict: false,
          schema: {
            type: "object",
            properties: properties,
            required: required,
            additionalProperties: false,
          },
        },
      }),
    })
      .then((res) => res.json())
      .then(async (result) => {
        if (result.arguments !== undefined) {
          setThreadLoading(false);
          let data = JSON.parse(result.arguments);
          setThreadResponse(data);
        }
      })
      .catch((err) => {
        console.log(144, pid);
      });
  };

  const handleReplyPage = () => {
    setPage("reply");
    setMailStatsChange({ ...mailStatsChange, replyGenerated: true });
  };

  const handleTicket = () => {
    fetch(post_API_CREATE_TICKET, {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        notes: threadResponse?.summary,
        tags: ["Query"],
        creator: "OutlookPlugin",
        Source: "OutlookPlugin",
        conversationId: "",
        channel:"Email",
        propertyId: pid,
        groupId: gid,
        status: "Pending",
        type: null,
        title: "Query",
        assignTo: email,
        statusNotes: [{ assignEmail: email, text: `Assigned to ${email}`, createdBy: "Outlook" }],
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
      });
  };


  useEffect(() => {
    Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, mailContextChange);
    Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, function (bodyTtext) {
      if (emailIntegration !== undefined) {
        if (questionSetDetails !== undefined) {
          let tools = [];
          if (questionSetDetails?.flowInvokeApi && questionSetDetails.flowInvokeApi?.isEnabled == true)
            tools = questionSetDetails.flowInvokeApi?.json;
          handleSummary((Office.context.mailbox?.initialData?.subject ?? '') + ' ' + bodyTtext["value"], questionSetDetails?.instructions, tools, questionSetDetails.openAiModel === "AzureGpt4" ? gAPI_AZURE_THREAD_DYNAMIC_SUMMARY : gAPI_THREAD_DYNAMIC_SUMMARY, questionSetDetails.openAiVerbosity);
        } else {
          let flow = emailIntegration?.channelDetails && emailIntegration?.channelDetails?.autonomousReplies;
          handleSummary((Office.context.mailbox?.initialData?.subject ?? '') + ' ' + bodyTtext["value"], flow?.instructions, [], questionSetDetails?.openAiModel === "AzureGpt4" ? gAPI_AZURE_THREAD_DYNAMIC_SUMMARY : gAPI_THREAD_DYNAMIC_SUMMARY, questionSetDetails.openAiVerbosity);
        }
      }
    });
  }, [pid]);

  useEffect(() => {
    if (threadResponse !== undefined) AddStats();
  }, [threadResponse]);

  useEffect(() => {
    if (threadResponse !== undefined)
      updateStats(mailStatsChange?.pasteToOutlook, mailStatsChange?.replyGenerated, mailStatsChange?.copyDraft);
  }, [mailStatsChange]);

  function AddStats(pasteToOutlook = false, replyGenerated = false, copyDraft = false) {
    fetch(API_EMAIL_STATS, {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        integrationId: iid,
        groupId: gid,
        propertyId: pid,
        email: authContext?.userPrincipalName,
        threadSummary: threadResponse?.summary,
        topic: threadResponse?.topics,
        urgency: threadResponse?.priority,
        type: "plugin",
        sentiment: threadResponse?.customer_sentiment,
        pasteToOutlook: pasteToOutlook,
        replyGenerated: replyGenerated,
        copyDraft: copyDraft,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result?.status) setStatsId(result.status);
      })
      .catch((err) => {
        console.log(144, pid);
      });
  }

  function updateStats(pasteToOutlook = false, replyGenerated = false, copyDraft = false) {
    fetch(`${API_EMAIL_STATS}/${statsId}`, {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: authContext?.userPrincipalName,
        threadSummary: threadResponse?.summary,
        topic: threadResponse?.topics,
        Urgency: threadResponse?.priority,
        type: "plugin",
        sentiment: threadResponse?.customer_sentiment,
        pasteToOutlook: pasteToOutlook,
        replyGenerated: replyGenerated,
        copyDraft: copyDraft,
      }),
    })
      .then((res) => res.json())
      .then((result) => { })
      .catch((err) => { });
  }

  function getUrgencyIcon(urgency) {
    var svg;
    if (urgency === "High") {
      svg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="#D0312D"
          class="bi bi-arrow-up-circle"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"
          />
        </svg>
      );
    } else if (urgency === "Medium") {
      svg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="#FFBF00"
          class="bi bi-arrow-right-circle"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
          />
        </svg>
      );
    } else if (urgency === "Low") {
      svg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="#5EDC1F"
          class="bi bi-arrow-down-circle"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"
          />
        </svg>
      );
    }
    return svg;
  }

  function getExpression(sentiment) {
    var svg;
    if (sentiment === "Positive") {
      svg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="#5EDC1F"
          width={20}
          height={20}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
          />
        </svg>
      );
    } else if (sentiment === "Neutral") {
      svg = (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width={16}
          height={16}
          className="yellow"
          viewBox="0 0 512.000000 512.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
            <path
              fill="#FFBF00"
              d="M2370 5113 c-379 -36 -661 -116 -980 -278 -378 -193 -717 -497 -965 -865 -104 -156 -232 -419 -294 -605 -49 -150 -89 -321 -113 -490 -17 -118 -17 -512 0 -630 42 -295 120 -553 242 -800 137 -280 272 -468 494 -691 221 -220 412 -357 681 -489 188 -92 309 -137 500 -185 500 -126 1002 -102 1490 71 150 53 408 183 540 271 302 202 573 480 769 788 72 113 188 353 235 486 235 662 194 1372 -115 1993 -124 250 -263 447 -458 648 -214 222 -430 379 -711 518 -296 146 -572 225 -900 255 -102 9 -333 11 -415 3z m545 -342 c628 -106 1158 -448 1511 -977 179 -267 296 -573 351 -909 24 -153 24 -497 0 -650 -108 -668 -474 -1222 -1042 -1580 -243 -153 -537 -261 -850 -312 -154 -24 -497 -24 -650 1 -657 107 -1198 456 -1557 1006 -168 257 -281 557 -335 885 -24 153 -24 497 0 650 81 497 291 912 636 1255 382 381 862 605 1401 654 108 10 418 -4 535 -23z"
            />
            <path
              fill="#FFBF00"
              d="M1402 3492 c-94 -34 -178 -123 -203 -215 -19 -69 -7 -175 27 -236 59 -109 153 -165 279 -165 94 -1 157 23 218 82 132 127 139 314 16 447 -87 94 -220 128 -337 87z"
            />
            <path
              fill="#FFBF00"
              d="M3530 3501 c-90 -30 -174 -103 -212 -186 -30 -68 -30 -180 0 -247 29 -66 102 -141 165 -169 78 -35 192 -34 269 4 71 35 130 101 159 176 27 73 23 185 -10 249 -57 110 -153 173 -274 178 -40 2 -83 0 -97 -5z"
            />
            <path
              fill="#FFBF00"
              d="M1507 1786 c-72 -26 -107 -76 -107 -153 0 -57 26 -105 72 -133 32 -20 53 -20 1088 -20 1035 0 1056 0 1088 20 101 62 97 213 -8 274 -35 21 -46 21 -1065 23 -851 2 -1037 0 -1068 -11z"
            />
          </g>
        </svg>
      );
    } else if (sentiment === "Negative") {
      svg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="#D0312D"
          width={20}
          height={20}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
          />
        </svg>
      );
    }
    return svg;
  }

  const handlePropertyChange = (e) => {
    handleProperty(e.target.value);
  }

  const handleSwitchProperty = () => {
    handleUpdateSettings({ gid: settings.gid, iid: settings.iid });
  };
  return (
    <Fragment>
      <div id="page">
        {page === "main" && (
          <div className="myma-modern-page">
            <div className="myma-summary-card">

              <div className="myma-summary-header">
                <p className="myma-summary-title">
                  <b>{threadResponse?.topics}</b>
                </p>
              </div>

              {threadLoading && (
                <div id="thread-loader" className="preloader-show">
                  <div
                    className="spinner-border color-highlight-myma"
                    role="status"
                    style={{ height: "1.5rem", width: "1.5rem" }}
                  ></div>
                </div>
              )}
              {/* {threadResponse?.email_history && <Fragment>
                                <h6 className="my-1">Latest Email: {moment(threadResponse?.email_history?.LastMessage).format('YYYY-MM-DD hh:mm')}</h6>
                                <h6 className="my-1">First Email: {moment(threadResponse?.email_history?.FirstMessage).format('YYYY-MM-DD hh:mm')}</h6>
                            </Fragment>} */}
              {threadResponse?.summary && (
                <p
                  className="myma-summary-text"
                  style={{
                    color:
                      reply === threadResponse?.summary
                        ? "#ef4A81"
                        : "#1f2937"
                  }}
                >
                  {threadResponse?.summary}
                </p>
              )}

              {(threadResponse?.name ||
                threadResponse?.check_in_date ||
                threadResponse?.check_out_date ||
                threadResponse?.adults ||
                threadResponse?.agent ||
                threadResponse?.corporate_code ||
                threadResponse?.group_code ||
                threadResponse?.property_name ||
                threadResponse?.booking_number ||
                threadResponse?.promo_code) && <hr />}

              <div className="myma-info-list">

                {threadResponse?.name && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <circle cx="12" cy="8" r="4" />
                        <path d="M4 21c0-4 3.5-7 8-7s8 3 8 7" />
                      </svg>
                    </span>
                    <span className="myma-info-label">
                      <IntlMessages id="main.name" />
                    </span>

                    <span className="myma-info-value">
                      {threadResponse?.name}
                    </span>
                  </div>
                )}

                {threadResponse?.property_name && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M3 21h18" />
                        <path d="M5 21V5l7-3 7 3v16" />
                        <path d="M9 8h1M14 8h1M9 12h1M14 12h1M9 16h1M14 16h1" />
                      </svg>
                    </span>

                    <span className="myma-info-label">
                      <IntlMessages id="main.property_name" />
                    </span>
                    <span className="myma-info-value">{threadResponse?.property_name}</span>
                  </div>
                )}

                {threadResponse?.booking_number && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <rect x="4" y="3" width="16" height="18" rx="2" />
                        <path d="M8 7h8M8 11h8M8 15h5" />
                      </svg>
                    </span>

                    <span className="myma-info-label">
                      <IntlMessages id="main.booking_number" />
                    </span>
                    <span className="myma-info-value ml-2"> {threadResponse?.booking_number}</span>

                  </div>
                )}

                {threadResponse?.check_in_date && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <rect x="3" y="5" width="18" height="16" rx="2" />
                        <path d="M16 3v4M8 3v4M3 9h18" />
                      </svg>
                    </span>
                    <span className="myma-info-label">
                      <IntlMessages id="main.check_in" />
                    </span>
                 <span className="myma-info-value">{moment(threadResponse?.check_in_date).format("dddd MMM D, YYYY")}</span>

                  </div>
                )}

                {threadResponse?.check_out_date && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <rect x="3" y="5" width="18" height="16" rx="2" />
                        <path d="M16 3v4M8 3v4M3 9h18" />
                      </svg>
                    </span>

                    <span className="myma-info-label">
                      <IntlMessages id="main.check_out" /></span>
                    <span className="myma-info-value ">{moment(threadResponse?.check_out_date).format("dddd MMM D, YYYY")}</span>

                  </div>
                )}

                {threadResponse?.adults && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <circle cx="9" cy="8" r="3" />
                        <path d="M3 21c0-3.5 2.5-6 6-6s6 2.5 6 6" />
                        <path d="M16 11c2.5 0 5 2 5 5M16 5a3 3 0 0 1 0 6" />
                      </svg>
                    </span>
                    <span className="myma-info-label"> <IntlMessages id="main.adults" /></span>
                    <span className="myma-info-value"> {threadResponse?.adults}</span>

                  </div>
                )}

                {threadResponse?.agent && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M4 5h16v14H4z" />
                      <path d="M7 8h10M7 12h6M7 16h4" />
                    </svg></span>
                    <span className="myma-info-label"><IntlMessages id="main.agent" /></span>
                    <span className="myma-info-value"> {threadResponse?.agent}
                    </span>

                  </div>
                )}

                {threadResponse?.corporate_code && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M4 5h16v14H4z" />
                      <path d="M7 8h10M7 12h6M7 16h4" />
                    </svg></span>
                    <span className="myma-info-label"><IntlMessages id="main.corporate_code" /></span>
                    <span className="myma-info-value">{threadResponse?.corporate_code}</span>

                  </div>
                )}

                {threadResponse?.group_code && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M4 5h16v14H4z" />
                      <path d="M7 8h10M7 12h6M7 16h4" />
                    </svg></span>
                    <span className="myma-info-label"> <IntlMessages id="main.group_code" /> </span>
                    <span className="myma-info-value ml-2">{threadResponse?.group_code}</span>

                  </div>
                )}

                {threadResponse?.promo_code && (
                  <div className="myma-info-row">
                    <span className="myma-info-icon">  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M4 5h16v14H4z" />
                      <path d="M7 8h10M7 12h6M7 16h4" />
                    </svg></span>
                    <span className="myma-info-label"> <IntlMessages id="main.promo_code" /> </span>


                    <span className="myma-info-value ml-2"> {threadResponse?.promo_code}</span>
                  </div>
                )}

              </div>
            </div>
            {threadResponse !== undefined && (
              <div className="myma-status-card">

                {threadResponse?.customer_sentiment && (
                  <div className="myma-status-row">
                    <div className="myma-status-left">

                      <span className="myma-sentiment-icon sentiment-icon">
                        {getExpression(threadResponse?.customer_sentiment)}
                      </span>

                      <span>
                        <IntlMessages id="main.sentiment" />
                      </span>

                    </div>

                    <span
                      className={`myma-status-pill sentiment-${threadResponse?.customer_sentiment?.toLowerCase()}`}
                    >
                      {threadResponse?.customer_sentiment}
                    </span>
                  </div>
                )}

                {threadResponse?.priority && (
                  <div className="myma-status-row">
                    <div className="myma-status-left">

                      <span className="myma-status-icon urgency-icon">
                        {getUrgencyIcon(threadResponse?.priority)}
                      </span>

                      <span>
                        <IntlMessages id="main.urgency" />
                      </span>

                    </div>

                    <span
                      className={`myma-status-pill priority-${threadResponse?.priority?.toLowerCase()}`}
                    >
                      {threadResponse?.priority}
                    </span>
                  </div>
                )}

                {threadResponse?.language && (
                  <div className="myma-status-row">

                    <div className="myma-status-left">

                      <span className="myma-status-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="#616366"
                          strokeWidth="1.7"
                        >
                          <circle cx="12" cy="12" r="9" />
                          <path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" />
                        </svg>
                      </span>

                      <span>
                        <IntlMessages id="main.language" />
                      </span>

                    </div>

                    <span className="myma-status-pill language-pill">
                      {Languages[threadResponse?.language] ||
                        threadResponse?.language}
                    </span>

                  </div>
                )}

              </div>
            )}
            {/* <div className="myma-status-card"> */}
            {propertyList !== undefined && propertyList.length > 0 && (
              <div className="myma-property-wrapper">

                <div className="myma-property-select-wrapper">

                  <select className={`${allowedProperty.length > 0 ? 'minimal' : ''} btn-full btn myma-property-select`}
                    onChange={handlePropertyChange}
                    value={pid}
                    style={{ textTransform: 'capitalize' }}
                  >
                    {propertyList
                      .filter((f) => allowedProperty.includes(f.id))
                      .map((p) => (
                        <option key={p.id} selected={pid === p.id ? true : false} value={p.id}>
                          {p.name}
                        </option>
                      ))}
                  </select>

                </div>

              </div>
            )}

            {threadResponse !== undefined && (
              <div className="myma-actions mt-2">

                {/* AI RESPONSE */}
                <button
                  type="button"
                  className="myma-ai-response-button"
                  onClick={() => {
                    setSelectedTemplate("");
                    handleReplyPage();
                  }}
                >
                  <span className="myma-ai-sparkle-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 3v4" />
                      <path d="M7 5h4" />
                      <path d="M9 7l1.2 3.8L14 12l-3.8 1.2L9 17l-1.2-3.8L4 12l3.8-1.2L9 7z" />

                      <path d="M17 9v3" />
                      <path d="M15.5 10.5h3" />
                      <path d="M17 12l.8 2.2L20 15l-2.2.8L17 18l-.8-2.2L14 15l2.2-.8L17 12z" />
                    </svg>
                  </span>

                  <span className="myma-ai-response-text">
                    <IntlMessages id="main.ai_response" />
                  </span>

                  {/* <span className="myma-ai-response-arrow">
    ›
  </span> */}
                </button>


                {/* TEMPLATE RESPONSE */}
                {emailIntegration?.channelDetails?.enableTemplates &&
                  emailIntegration?.channelDetails?.templates?.length > 0 && (
                    <button
                      type="button"
                      className="myma-action-button"
                      onClick={() => {
                        setSelectedTemplate("");
                        setShowTemplateModal(true);
                      }}
                    >
                      <span className="myma-action-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                        >
                          <rect x="4" y="3" width="16" height="18" rx="2" />
                          <path d="M8 7h8M8 11h5M8 15h8" />
                        </svg>
                      </span>

                      <span className="myma-action-text">
                        <IntlMessages id="main.template_response" />
                      </span>

                      {/* <span className="myma-action-arrow">›</span> */}
                    </button>
                  )}


                {/* CONVERT TO TICKET */}
                <button
                  type="button"
                  className="myma-action-button"
                  onClick={() => setPage("ticket")}
                >
                  <span className="myma-action-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M4 5h16v14H4z" />
                      <path d="M7 8h10M7 12h6M7 16h4" />
                    </svg>
                  </span>

                  <span className="myma-action-text">
                    <IntlMessages id="main.converttoticket" />
                  </span>

                  {/* <span className="myma-action-arrow">›</span> */}
                </button>


                {/* SWITCH PROPERTY */}
                {isSuperAdmin && (
                  <button
                    type="button"
                    className="myma-action-button"
                    onClick={() => setPage("switch")}
                  >
                    <span className="myma-action-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      >
                        <path d="M4 21V5l8-3 8 3v16" />
                        <path d="M8 9h8M8 13h8M8 17h5" />
                      </svg>
                    </span>

                    <span className="myma-action-text">
                      <IntlMessages id="main.switch_property" />
                    </span>

                    {/* <span className="myma-action-arrow">›</span> */}
                  </button>
                )}

              </div>
            )}
          </div>
        )}
        {page === "switch" && isSuperAdmin && <Fragment>
          <div className="page-content header-clear-small">
            <div className="row my-3">
              <div className="col-2">
                <a href="#" onClick={() => setPage("main")} className="ml-3" style={{ float: "left" }}>
                  <span className="color-dark-dark">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-circle"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                      />
                    </svg>{" "}
                  </span>
                </a>
              </div>

            </div>
            <div className="col-12">
              <div className="row mb-3" style={{ margin: "5px" }}>
                <div className="form-custom form-label mb-3">
                  <input
                    type="text"
                    onChange={(e) => setSettings({ ...settings, gid: e.target.value })}
                    value={settings.gid}
                    className="form-control rounded-xs  form-control"
                    id="gid"
                  />
                  <label className="color-theme form-label-active"><IntlMessages id="main.Group_id" /></label>
                </div>
                <div className="form-custom form-label mb-3">
                  <input
                    type="text"
                    onChange={(e) => setSettings({ ...settings, iid: e.target.value })}
                    value={settings.iid}
                    className="form-control rounded-xs  form-control"
                    id="iid"
                  />
                  <label className="color-theme form-label-active"><IntlMessages id="main.integration_id" /></label>
                </div>
              </div>
            </div>

            <div className="col-12 text-center mb-2">
              <button
                type="submit"
                onClick={handleSwitchProperty}
                className="btn-full btn button-myma-primary"
                style={{ width: "55%" }}
                disabled={!settings.gid || !settings.iid}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  width={15}
                  height={15}
                >
                  <path d="M6,14.1818182 L6,17.4545455 L18,17.4545455 L18,14.1818182 M12,6 L12,14 M8.18181818,9.81818182 L12,6 L15.8181818,9.81818182" />
                </svg>
                <span className="ml-1" style={{ textTransform: "none" }}>
                  <IntlMessages id="main.submit" />
                </span>
              </button>
            </div>
          </div>
        </Fragment>
        }

        {page === "reply" && threadResponse !== undefined && (
          <Reply
            userLang={locale}
            threadResponse={threadResponse}
            mailStatsChange={mailStatsChange}
            handleManage={handleManage}
            emailLang={threadResponse?.language ? threadResponse.language : "en"}
            initialReply={selectedTemplate || undefined}
            cid={cid}
            gid={gid}
            pid={pid}
            propertyDetails={propertyDetails}
            emailIntegration={emailIntegration}
            questionSetDetails={questionSetDetails}
          ></Reply>
        )}
        {page === "help" && <Help gid={gid} pid={pid} service={service}></Help>}
        {page === "search" && (
          <Search
            pid={pid}
            cid={cid}
            reply={reply}
            threadResponse={threadResponse}
            emailIntegration={emailIntegration}
            responseList={responseList}
            propertyDetails={propertyDetails}
            handleManage={handleManage}
            questionSetDetails={questionSetDetails}
            gid={gid}
          ></Search>
        )}
        {page === "ari" && <ARI gid={gid} integration={ariIntegration} pid={pid} checkInDate={threadResponse?.check_in_date}
          checkOutDate={threadResponse?.check_out_date} corporateCode={threadResponse?.corporate_code} handleManage={handleManage}></ARI>}
        {page === "ticket" && (
          <Ticket
            gid={gid}
            integration={ariIntegration}
            pid={pid}
            propertyDetails={propertyDetails}
            lang={locale}
            handleManage={handleManage}
          ></Ticket>
        )}

        <Footer reply={reply} ariIntegration={ariIntegration} handleManage={handleManage} activePage={page}></Footer>
      </div>
      {/* Template selection modal */}
      {showTemplateModal && (
        <div
          className="row additional-modal"
          style={{ position: "fixed", top: "60px", left: "0px", right: "0px", zIndex: 1200, padding: '0.5rem' }}
        >
          <div className="modal-box" style={{ padding: '0.5rem' }}>
            <div className="col-12 mt-4">
              <div className="form-custom form-label mt-3">
                <label className="color-theme form-label-active"><IntlMessages id="main.select_template" /></label>
                <select
                  value={selectedTemplate}
                  onChange={(e) => setSelectedTemplate(e.target.value)}
                  className="form-control rounded-xs"
                  style={{ height: "40px" }}
                >
                  <option value="">-- choose a template --</option>
                  {emailIntegration?.channelDetails?.templates && emailIntegration?.channelDetails?.templates.length > 0
                    ? emailIntegration.channelDetails.templates.map((t, i) => (
                      <option key={`tpl-${i}`} value={t?.details}>
                        {t.name}
                      </option>
                    ))
                    : null}
                </select>
              </div>
              <div className="row mt-3" style={{ margin: "8px" }}>
                <div className="col-6">
                  <button
                    type="button"
                    onClick={() => setShowTemplateModal(false)}
                    className="btn-full btn border-myma reply-button"
                  >
                    <IntlMessages id="main.cancel" />
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button"
                    onClick={() => { setShowTemplateModal(false); handleReplyPage(); }}
                    disabled={!selectedTemplate}
                    className="btn-full btn border-green-dark reply-button"
                    style={{ opacity: selectedTemplate ? 1 : 0.6 }}
                  >
                    <IntlMessages id="main.submit" />
                  </button>
                </div>
              </div>
            </div>
            <button className="close-btn" onClick={() => setShowTemplateModal(false)}>
              &times;
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};
export default Main;
